module.exports = __webpack_public_path__ + "static/media/azure.a32409a2.png";